<template>
    <div>
        <div class="nav">{{title}}</div>
    </div>
</template>

<script>
export default {
    data(){
        return {

        }
    },
    props:['title']
}
</script>

<style>
.nav {
    width: 100%;
    height: 3.7rem;
    text-align: center;
    line-height: 3.7rem;
    background: #11a093;
    color: #ffffff;
    font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/cusBread.vue